export default "__VITE_ASSET__7b313d6f__"